import { type HTMLAttributes } from 'react';
import { cn } from '../lib/cn.js';

/** Loading placeholder — pulse animation over a muted block. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}
